import { render, staticRenderFns } from "./PreQuestion4.vue?vue&type=template&id=4e54d3c9&"
import script from "./PreQuestion4.vue?vue&type=script&lang=js&"
export * from "./PreQuestion4.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion4.vue?vue&type=style&index=0&id=4e54d3c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports